const heroSlider = document.querySelector(".hero__slider");
const aboutMeSlider = document.querySelector(".about-me__slider");
const projectsSlider = document.querySelector(".projects__slider");
const aboutMeDetailSliderSectionSlider = document.querySelector(
  ".about-me-detail-slider-section__slider"
);
const blogSlider = document.querySelector(".blog-slider-section__slider");
const arhievenementsSlider = document.querySelector(".arhievenements__slider");
const advantagesSlider = document.querySelector(".advantages__slider");

let swiperSlider = new Swiper(heroSlider, {
  centeredSlides: true,
  spaceBetween: 15,
  loop: true,
  navigation: {
    nextEl: ".slider-button--next",
    prevEl: ".slider-button--prev",
  },
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    1199: {
      slidesPerView: 3,
    },
    991: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    767: {
      slidesPerView: 1,
    },
  },
});

let swiperSlider2 = new Swiper(aboutMeSlider, {
  centeredSlides: false,
  slidesPerView: 2.2,
  spaceBetween: 10,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    1199: {
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    575: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
  },
});

let swiperSlider3 = new Swiper(projectsSlider, {
  centeredSlides: false,
  spaceBetween: 80,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: ".slider-button--next",
    prevEl: ".slider-button--prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    575: {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
    },
    769: {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
    },
    1399: {
      slidesPerView: 2.2,
      spaceBetween: 30,
    },
    1599: {
      slidesPerView: 1.1,
      spaceBetween: 45,
    },
  },
});

let swiperSlider4 = new Swiper(aboutMeDetailSliderSectionSlider, {
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 0,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: ".slider-button--next",
    prevEl: ".slider-button--prev",
  },
});

let swiperSlider5 = new Swiper(blogSlider, {
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 0,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: ".slider-button--next",
    prevEl: ".slider-button--prev",
  },
});

let swiperSlider6 = new Swiper(arhievenementsSlider, {
  centeredSlides: false,
  slidesPerView: 3,
  spaceBetween: 10,
  grabCursor: false,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    767: {
      scrollbar: {
        el: ".swiper-scrollbar",
        grabCursor: true,
      },
    },
  },
});

let swiperSlider7 = new Swiper(advantagesSlider, {
  centeredSlides: false,
  slidesPerView: "auto",
  spaceBetween: 10,
  grabCursor: false,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    1399: {
      scrollbar: {
        el: ".swiper-scrollbar",
        grabCursor: true,
      },
    },
  },
});
